import { useState, useEffect } from 'react'
import * as microConfig from '@/views/micro/config'

/**
 * 微应用配置 Hook
 * 用于管理微应用 URL 和配置
 */
export const useMicroConfig = () => {
    // 微应用 URL 状态
    const [microUrl, setMicroUrl] = useState(microConfig.MICRO_APPS[0].url)

    // 初始化时获取微应用 URL
    useEffect(() => {
        microConfig.MICRO_APPS_URL().then(({ auth }) => {
            !microUrl && setMicroUrl(auth)
        })
    }, [])

    return {
        microUrl
    }
}

export default useMicroConfig